import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "betslip-header" }
const _hoisted_2 = {
  key: 0,
  class: "betslip-load-booking"
}
const _hoisted_3 = { class: "booking-search-container" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "booking-message success"
}
const _hoisted_7 = {
  key: 1,
  class: "booking-message error"
}
const _hoisted_8 = {
  key: 1,
  class: "betslip-empty-container"
}
const _hoisted_9 = { class: "booking-header" }
const _hoisted_10 = { class: "booking-title" }
const _hoisted_11 = { class: "booking-code-box" }
const _hoisted_12 = { class: "booking-code" }
const _hoisted_13 = {
  key: 0,
  class: "barcode-box"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "booking-info" }
const _hoisted_16 = { class: "info-row" }
const _hoisted_17 = { class: "info-row" }
const _hoisted_18 = { class: "expires-text" }
const _hoisted_19 = { class: "booking-actions" }
const _hoisted_20 = { class: "success-content" }
const _hoisted_21 = { class: "success-text" }
const _hoisted_22 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_23 = {
  key: 3,
  class: "view-last-bet"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "betslip-content" }
const _hoisted_26 = { class: "bet-item-header" }
const _hoisted_27 = { class: "game-name" }
const _hoisted_28 = { class: "bet-item-actions" }
const _hoisted_29 = { class: "bet-odds" }
const _hoisted_30 = ["aria-label", "onClick"]
const _hoisted_31 = { class: "bet-item-details" }
const _hoisted_32 = { class: "draws-section" }
const _hoisted_33 = { class: "draws-header" }
const _hoisted_34 = { class: "draws-label" }
const _hoisted_35 = ["aria-expanded", "onClick"]
const _hoisted_36 = { class: "draw-date" }
const _hoisted_37 = ["aria-label", "onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "market-name" }
const _hoisted_40 = {
  key: 0,
  class: "bet-type"
}
const _hoisted_41 = {
  key: 1,
  class: "numbers-section"
}
const _hoisted_42 = { class: "numbers-label" }
const _hoisted_43 = { class: "number-circles" }
const _hoisted_44 = { class: "bet-inputs-row" }
const _hoisted_45 = { class: "input-fieldset" }
const _hoisted_46 = { class: "input-fieldset-label" }
const _hoisted_47 = { class: "input-wrapper" }
const _hoisted_48 = { class: "currency" }
const _hoisted_49 = ["value", "onInput", "onBlur", "onFocus"]
const _hoisted_50 = { class: "input-fieldset readonly" }
const _hoisted_51 = { class: "input-fieldset-label" }
const _hoisted_52 = { class: "input-wrapper" }
const _hoisted_53 = { class: "currency" }
const _hoisted_54 = { class: "win-value" }
const _hoisted_55 = { class: "betslip-footer" }
const _hoisted_56 = { class: "footer-actions" }
const _hoisted_57 = ["title"]
const _hoisted_58 = ["checked"]
const _hoisted_59 = { class: "promotion-offer-inline-text" }
const _hoisted_60 = { class: "promotion-offer-inline-label" }
const _hoisted_61 = { class: "promotion-offer-inline-detail" }
const _hoisted_62 = {
  key: 0,
  class: "promotion-offer-error"
}
const _hoisted_63 = { class: "summary-box" }
const _hoisted_64 = { class: "summary-item" }
const _hoisted_65 = { class: "summary-label" }
const _hoisted_66 = { class: "summary-value" }
const _hoisted_67 = { class: "summary-item" }
const _hoisted_68 = { class: "summary-label" }
const _hoisted_69 = { class: "summary-value" }
const _hoisted_70 = {
  key: 1,
  class: "expired-bet-options"
}
const _hoisted_71 = { class: "expired-message" }
const _hoisted_72 = { class: "warning-text" }
const _hoisted_73 = { class: "expired-actions" }
const _hoisted_74 = {
  key: 2,
  class: "inline-error-message"
}
const _hoisted_75 = { class: "error-text" }
const _hoisted_76 = {
  key: 3,
  class: "book-bet-restriction-message"
}
const _hoisted_77 = { class: "warning-text" }
const _hoisted_78 = { class: "betslip-action-buttons" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = {
  key: 0,
  class: "payout-max-warning"
}
const _hoisted_81 = ["disabled"]
const _hoisted_82 = { class: "terms-text" }

import {
  computed,
  watch,
  ref,
  nextTick,
  onMounted,
  onUnmounted,
  unref,
} from "vue";
import { useBetslipStore } from "../stores/betslip";
import type { BetslipItem } from "../stores/betslip";
import { useToast } from "../composables/useToast";
import { useGameStore } from "../stores/game";
import { useTransactionsStore } from "../stores/transactions";
import { useAuthStore } from "../stores/auth";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { formatCurrency, formatOdds } from '../utils/currency';
import { useBetSettings } from "../composables/useBetSettings";
import {
  calcPotentialWin,
  displayPotentialWin,
  normalizeStakeValue,
  sumPotentialWins,
  toNumber,
} from "../utils/betLimits";
import {
  parseCommittedStakeInput,
  parseStakePreviewAmount,
  sanitizeStakeInputString,
} from "../utils/stakeInput";
import { iframeCommunication } from "../utils/iframeCommunication";
import { usePromotionStore } from "../stores/promotion";
import { promotionBannerLabel } from '../types/promotion'
import { usePromotionSync } from '../composables/usePromotionSync'
import { scrollElementIntoViewAfterRender } from "../utils/scrollToElement";
import BaseModal from "./BaseModal.vue";
import TransactionDetails from "./wagers/TransactionDetails.vue";
import { useRebetFromTransaction } from "../composables/useRebetFromTransaction";


export default /*@__PURE__*/_defineComponent({
  __name: 'BetSlip',
  emits: ["close", "selectDraws", "drawsChanged", "clearedAfterSubmission"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const betslipContainer = ref<HTMLElement | null>(null);
const bookedBetSuccessRef = ref<HTMLElement | null>(null);
const betslipSuccessRef = ref<HTMLElement | null>(null);

const { t } = useI18n();
const gameStore = useGameStore();
const transactionsStore = useTransactionsStore();
const betslipStore = useBetslipStore();
const authStore = useAuthStore();
const promotionStore = usePromotionStore();
const { refreshPromotions } = usePromotionSync();
const promotionLookupDone = ref(false);
const router = useRouter();
const route = useRoute();
const { removeBet, clearBetslip: storeClearBetslip, updateLastStake } = betslipStore;
const betslip = computed(() => betslipStore.betslip);
const { showToast } = useToast();
const isProcessingBet = ref(false);
const showSuccess = ref(false);
const isUpdatingFromProps = ref(false);
const isClearingBetslip = ref(false);
const localStakeValues = ref<{ [key: number]: string }>({});
const stakeEditingByIndex = ref<Record<number, boolean>>({});
const showExpiredBetOptions = ref(false);
const expandedDraws = ref<{ [key: number]: boolean }>({});
const expiredBets = ref<Array<{ betIndex: number; drawIndex: number; draw: { draw_date: string; cutoff: string; event_id: number } }>>([]);
const bookingCodeInput = ref('');
const isLoadingBooking = ref(false);
const bookingMessage = ref('');
const bookingErrorMessage = ref('');
const currentBookingCode = ref<string | null>(null);
const isProcessingBookBet = ref(false);
const bookBetSuccessData = ref<{
  booking_code: string;
  barcode?: string;
  expires_at?: string;
  total_bet_amount?: number;
  bets?: BetslipItem[];
} | null>(null);

const clearBetslip = (resetSuccess: boolean | MouseEvent = true) => {
  const shouldReset = typeof resetSuccess === 'boolean' ? resetSuccess : true;
  isClearingBetslip.value = true;
  if (shouldReset) {
    showSuccess.value = false;
  }
  storeClearBetslip();
  
  // Notify upstream that betslip was cleared
  iframeCommunication.sendMessage('betslip-cleared');

  setTimeout(() => {
    isClearingBetslip.value = false;
  }, 100);
};

const cleanupTimer = ref<number | null>(null);
const inlineError = ref<string | null>(null);
const isMobile = ref(false);
const openDrawDropdownIndex = ref<number | null>(null);
const clickOutsideHandler = ref<((event: MouseEvent) => void) | null>(null);
const isLastBetModalOpen = ref(false);
const { applyRebetFromCurrentTransaction, isRebetting } = useRebetFromTransaction();
const isLoadingLastBet = ref(false);

const {
  betMin,
  betMax,
  payoutMax,
  payoutMaxPerBetslip,
  betLimit,
  betDefault,
  currencySymbol,
  currencyCode,
  allowDecimals,
} = useBetSettings();

const bets = computed(() => betslip.value || []);

const isNormalizingStakes = ref(false);

const getBetLineMultipliers = (bet: BetslipItem) => {
  const drawCount = Array.isArray(bet.draws) ? bet.draws.length : 1;
  const numBets = typeof bet.numBets === "number" && bet.numBets > 0 ? bet.numBets : 1;
  return { drawCount, numBets };
};

const getStakeNormalizeOptions = () => ({
  betMin: unref(betMin),
  betMax: unref(betMax),
  payoutMax: unref(payoutMaxPerBetslip) ? 0 : unref(payoutMax),
  allowDecimals: unref(allowDecimals),
});

const formatStakeInputValue = (stake: number): string => {
  if (!stake || stake <= 0) return "";
  if (unref(allowDecimals)) {
    return (Math.round(stake * 100) / 100).toString();
  }
  return String(Math.floor(stake));
};

const isStakeFieldEditing = (index: number): boolean =>
  Boolean(stakeEditingByIndex.value[index]);

const getStakeDisplayValue = (index: number): string => {
  if (isStakeFieldEditing(index)) {
    return localStakeValues.value[index] ?? "";
  }
  const stake = bets.value[index]?.stake ?? 0;
  if (stake > 0) {
    return formatStakeInputValue(stake);
  }
  return "";
};

const setRawBetStake = (index: number, stake: number) => {
  if (!bets.value[index]) return;
  isNormalizingStakes.value = true;
  const updatedBets = [...bets.value];
  updatedBets[index] = { ...updatedBets[index], stake: Math.max(0, stake) };
  betslipStore.betslip = updatedBets;
  betslipStore.saveToStorage();
  nextTick(() => {
    isNormalizingStakes.value = false;
  });
};

const effectiveStakeForBet = (index: number): number => {
  if (isStakeFieldEditing(index)) {
    return parseStakePreviewAmount(localStakeValues.value[index] ?? "");
  }
  return bets.value[index]?.stake ?? 0;
};

const betPotentialInputs = computed(() =>
  bets.value.map((bet, index) => {
    const { drawCount, numBets } = getBetLineMultipliers(bet);
    return {
      stake: effectiveStakeForBet(index),
      odds: toNumber(bet.odds),
      drawCount,
      numBets,
    };
  })
);

const lineDisplayPotentials = computed(() => {
  const inputs = betPotentialInputs.value;
  if (!inputs.length) return [];

  return inputs.map((line) => {
    const potentialWin = calcPotentialWin(
      line.stake,
      line.odds,
      line.drawCount ?? 1,
      line.numBets ?? 1
    );
    if (unref(payoutMaxPerBetslip)) {
      return potentialWin;
    }
    return displayPotentialWin(
      line.stake,
      line.odds,
      unref(payoutMax),
      line.drawCount,
      line.numBets
    );
  });
});

const applyNormalizedStake = (index: number, rawStake: number) => {
  if (!bets.value[index]) return;

  // Single-line promos lock the one stake to the face value. Multi-line
  // free bets keep per-line stakes (Y, Z, …) and must sum to the promo total.
  if (
    promotionStore.isAppliedOnSlip &&
    promotionStore.activePromotion?.singleLineOnly
  ) {
    rawStake = promotionStore.activePromotion.stake;
  }

  const bet = bets.value[index];
  const { drawCount, numBets } = getBetLineMultipliers(bet);
  const odds = toNumber(bet.odds);
  const stakeValue = normalizeStakeValue(rawStake, {
    ...getStakeNormalizeOptions(),
    odds,
    drawCount,
    numBets,
  });

  isNormalizingStakes.value = true;
  const updatedBets = [...bets.value];
  updatedBets[index] = { ...updatedBets[index], stake: stakeValue };
  betslipStore.betslip = updatedBets;
  betslipStore.saveToStorage();
  if (stakeValue > 0) {
    updateLastStake(stakeValue);
  }
  nextTick(() => {
    isNormalizingStakes.value = false;
  });
};

const removeBetAtIndex = (displayIndex: number) => {
  const betToRemove = bets.value[displayIndex];
  if (betToRemove) {
    iframeCommunication.sendMessage('bet-removed', { 
      bet: betToRemove,
      index: displayIndex 
    });
  }
  removeBet(displayIndex);
};

const closeBetslip = () => {
  emit('close');
};

const isEmpty = computed(() => {
  if (!bets.value || bets.value.length === 0) return true;
  return bets.value.some(
    (bet) => !Array.isArray(bet.draws) || bet.draws.length === 0 || !bet.stake || bet.stake <= 0
  );
});

const isAuthenticated = computed(() => authStore.isAuthenticated);

const hasAccountForBooking = computed(() => {
  const rawAccount = route.query.account;
  const fromRoute =
    typeof rawAccount === 'string'
      ? rawAccount
      : Array.isArray(rawAccount)
        ? rawAccount[0]
        : '';
  if (fromRoute && String(fromRoute).trim()) {
    return true;
  }
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('account');
    if (fromUrl && fromUrl.trim()) {
      return true;
    }
  } catch {
    /* ignore */
  }
  const account =
    authStore.account ||
    (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('auth_account') : null);
  return !!account && String(account).trim().length > 0;
});

const hasCurrencyForGameSettings = computed(() => {
  if (gameStore.getBetSettings?.currency_code) {
    return true;
  }
  const raw = route.query.currency;
  const fromRoute =
    typeof raw === 'string'
      ? raw
      : Array.isArray(raw)
        ? raw[0]
        : '';
  if (fromRoute && String(fromRoute).trim()) {
    return true;
  }
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('currency');
    if (fromUrl && fromUrl.trim()) {
      return true;
    }
  } catch {
    /* ignore */
  }
  const c =
    typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('auth_currency') : null;
  return !!c && String(c).trim().length > 0;
});

const showBookABetModule = computed(() => {
  if (promotionStore.isAppliedOnSlip) return false;
  const settings = gameStore.getBetSettings;
  const modules = settings?.enabled_modules;
  if (Array.isArray(modules)) {
    return modules.includes('book_a_bet');
  }
  if (!settings && hasAccountForBooking.value && hasCurrencyForGameSettings.value) {
    return true;
  }
  return false;
});

const showPromotionModule = computed(() =>
  promotionStore.isModuleEnabled(gameStore.getBetSettings?.enabled_modules)
);

const showPromotionOffer = computed(
  () =>
    showPromotionModule.value &&
    isAuthenticated.value &&
    promotionLookupDone.value &&
    promotionStore.isActive
);

const promotionBannerText = computed(() => {
  const promo = promotionStore.activePromotion;
  if (!promo) return '';
  return promotionBannerLabel(promo);
});

const handlePromotionApplyToggle = (event: Event) => {
  const checked = (event.target as HTMLInputElement).checked;
  promotionStore.setApplyToSlip(checked);
  if (!checked || !promotionStore.activePromotion) return;

  // Fill the face amount only when there is a single line. Do not copy it
  // onto every line — the promo covers the slip total (Y + Z + … = X).
  if (bets.value.length === 1) {
    applyNormalizedStake(0, promotionStore.activePromotion.stake);
  }
};

const resolveBetGameSlugs = (): string[] => {
  const detail = gameStore.getGameDetail;
  return bets.value
    .map((bet) => {
      if (detail?.slug && String(bet.game_id) === String(detail.id)) {
        return detail.slug.toLowerCase();
      }
      const name = String(bet.game_name || '').trim().toLowerCase();
      return name ? name.replace(/\s+/g, '-') : '';
    })
    .filter(Boolean);
};

/** Book-a-bet is only for a single game; online slip may hold multiple games for placing bets. */
const distinctGameIdCount = computed(() => {
  const ids = new Set<number>();
  for (const bet of bets.value) {
    const raw = bet?.game_id;
    const gid = typeof raw === 'number' ? raw : parseInt(String(raw ?? ''), 10);
    if (Number.isFinite(gid) && gid > 0) {
      ids.add(gid);
    }
  }
  return ids.size;
});

const distinctDrawKeyCount = computed(() => {
  const drawKeys = new Set<string>();
  for (const bet of bets.value) {
    const draws = Array.isArray(bet?.draws) ? bet.draws : [];
    for (const draw of draws) {
      const eventId =
        typeof draw?.event_id === 'number'
          ? draw.event_id
          : parseInt(String(draw?.event_id ?? ''), 10);
      if (Number.isFinite(eventId) && eventId > 0) {
        drawKeys.add(`event:${eventId}`);
        continue;
      }

      const drawDate = typeof draw?.draw_date === 'string' ? draw.draw_date.trim() : '';
      if (drawDate) {
        drawKeys.add(`date:${drawDate}`);
      }
    }
  }
  return drawKeys.size;
});

const singleGamePerTicketEnabled = computed(
  () =>
    gameStore.getBetSettings?.client_surface_ui?.online?.single_game_per_ticket ===
    true
);

const useOnlinePlatformPrintModal = computed(() => {
  const v = gameStore.getBetSettings?.client_surface_ui?.online?.use_platform_print_modal;
  return v !== false;
});

const hasMixedGamesForBookBet = computed(() => distinctGameIdCount.value > 1);

const hasMixedDrawsForBookBet = computed(() => distinctDrawKeyCount.value > 1);

const bookBetRestrictionMessage = computed(() => {
  if (!showBookABetModule.value) return '';
  if (hasMixedGamesForBookBet.value && hasMixedDrawsForBookBet.value) {
    return t('betslip.bookBetDifferentGamesAndDrawsDisabled');
  }
  if (hasMixedGamesForBookBet.value) {
    return singleGamePerTicketEnabled.value
      ? t('betslip.bookBetDifferentGamesDisabled')
      : t('betslip.bookBetDifferentGamesDisabled');
  }
  if (hasMixedDrawsForBookBet.value) {
    return t('betslip.bookBetDifferentDrawsDisabled');
  }
  return '';
});

const isBookBetDisabled = computed(() => {
  if (!showBookABetModule.value) return true;
  return Boolean(
    isProcessingBookBet.value ||
      isEmpty.value ||
      showExpiredBetOptions.value ||
      hasMixedGamesForBookBet.value ||
      hasMixedDrawsForBookBet.value ||
      exceedsBetslipPayoutMax.value
  );
});

const totalRawPotentialWin = computed(() => sumPotentialWins(betPotentialInputs.value));

const exceedsBetslipPayoutMax = computed(
  () =>
    unref(payoutMaxPerBetslip) &&
    unref(payoutMax) > 0 &&
    totalRawPotentialWin.value > unref(payoutMax)
);

const betNowPayoutMaxMessage = computed(() => {
  if (!exceedsBetslipPayoutMax.value) return "";
  return t("betslip.maxPossibleWinExceeds", {
    amount: formatCurrency(unref(payoutMax), unref(displayCurrency)),
  });
});

const totalStake = computed(() => {
  if (!bets.value) return 0;
  return bets.value.reduce((total, bet, index) => {
    const drawCount = Array.isArray(bet.draws) ? bet.draws.length : 1;
    const numBets = typeof bet.numBets === "number" && bet.numBets > 0 ? bet.numBets : 1;
    return total + effectiveStakeForBet(index) * numBets * drawCount;
  }, 0);
});

const totalReturns = computed(() => {
  if (!bets.value.length) return 0;
  if (unref(payoutMaxPerBetslip)) {
    return totalRawPotentialWin.value;
  }
  return lineDisplayPotentials.value.reduce((total, value) => total + value, 0);
});

const displayCurrency = computed((): string => {
  return unref(currencySymbol) || '';
});

/** ISO currency code for API / free-bet validation (not the display symbol). */
const sessionCurrencyCode = computed((): string => {
  const fromSettings = unref(currencyCode);
  if (fromSettings && String(fromSettings).trim()) {
    return String(fromSettings).trim();
  }
  const raw = route.query.currency;
  const fromRoute =
    typeof raw === 'string'
      ? raw
      : Array.isArray(raw)
        ? raw[0]
        : '';
  if (fromRoute && String(fromRoute).trim()) {
    return String(fromRoute).trim();
  }
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('currency');
    if (fromUrl && fromUrl.trim()) {
      return fromUrl.trim();
    }
  } catch {
    /* ignore */
  }
  const fromSession =
    typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('auth_currency') : null;
  return fromSession && String(fromSession).trim() ? String(fromSession).trim() : '';
});

const promotionSlipValidationError = computed(() => {
  if (!promotionStore.isAppliedOnSlip || isEmpty.value) return '';
  return (
    promotionStore.validateSlip({
      lineCount: bets.value.length,
      totalStake: totalStake.value,
      currency: unref(sessionCurrencyCode),
      gameSlugs: resolveBetGameSlugs(),
    }) ?? ''
  );
});

let lastPromotionNotifyKey = '';
watch(
  () => [
    promotionStore.isAppliedOnSlip,
    bets.value.length,
    totalStake.value,
    promotionStore.activePromotion?.id,
  ],
  () => {
    if (!promotionStore.isAppliedOnSlip || isEmpty.value) {
      lastPromotionNotifyKey = '';
      return;
    }
    const err = promotionStore.validateSlip({
      lineCount: bets.value.length,
      totalStake: totalStake.value,
      currency: unref(sessionCurrencyCode),
      gameSlugs: resolveBetGameSlugs(),
    });
    if (err) return;
    const key = `${promotionStore.activePromotion?.id}:${bets.value.length}:${totalStake.value}`;
    if (key === lastPromotionNotifyKey) return;
    lastPromotionNotifyKey = key;
    promotionStore.notifyApplied({
      betCount: bets.value.length,
      gameSlugs: resolveBetGameSlugs(),
    });
  },
  { deep: true }
);

const formatCurrencyValue = (value: number) => {
  return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const formatOddsValue = (value: number | string | undefined) => {
  if (value === undefined) return '';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

const useAltNameForMarket = computed(
  () => gameStore.getBetSettings?.client_surface_ui?.use_alt_name_for_market === true
);

const formatMarketDisplay = (bet: BetslipItem) => {
  const marketName = bet.market_name || t('betslip.standardBet');
  if (useAltNameForMarket.value) {
    return marketName;
  }

  let description = bet.market_description || '';
  
  if (description && bet.specifier) {
    description = description.replace('{value}', String(bet.specifier));
  }
  
  if (description) {
    return `${marketName}: ${description}`;
  }
  return marketName;
};

const focusBetslipOutcomeSection = (
  getTarget: () => HTMLElement | null | undefined,
  block: 'start' | 'end' | 'center' | 'nearest' = 'start'
) => {
  void scrollElementIntoViewAfterRender(getTarget, { block, offset: 16, focus: true });
};

const scrollToBottom = () => {
  const container = betslipContainer.value;
  if (!container) return;

  const scrollTargets: HTMLElement[] = [];
  const modalHost = container.closest('.mobile-betslip-content, .desktop-modal-box');
  if (modalHost instanceof HTMLElement) {
    scrollTargets.push(modalHost);
  }
  scrollTargets.push(container);

  for (const target of scrollTargets) {
    if (target.scrollHeight > target.clientHeight + 1) {
      target.scrollTo({ top: target.scrollHeight, behavior: 'smooth' });
    }
  }
};

watch(
  betslip,
  async (newBets: BetslipItem[]) => {
    if (
      isNormalizingStakes.value ||
      isUpdatingFromProps.value ||
      isClearingBetslip.value ||
      !newBets ||
      !Array.isArray(newBets) ||
      newBets.length === 0
    ) {
      return;
    }
    await nextTick();

    let needsUpdate = false;
    const updatedBets = newBets.map((bet) => {
      const { drawCount, numBets } = getBetLineMultipliers(bet);
      const rawStake = bet.stake ?? unref(betDefault);
      const normalizedStake = normalizeStakeValue(rawStake, {
        ...getStakeNormalizeOptions(),
        odds: toNumber(bet.odds),
        drawCount,
        numBets,
      });
      if (normalizedStake !== bet.stake) {
        needsUpdate = true;
        return { ...bet, stake: normalizedStake };
      }
      return bet;
    });

    if (!needsUpdate) return;

    isNormalizingStakes.value = true;
    betslipStore.betslip = updatedBets;
    betslipStore.saveToStorage();
    nextTick(() => {
      isNormalizingStakes.value = false;
    });
  },
  { immediate: true, deep: true }
);

watch(() => bets.value.length, (newLength, oldLength) => {
  if (newLength > oldLength && newLength > 0) scrollToBottom();
});

watch(bookBetSuccessData, (data) => {
  if (data) {
    focusBetslipOutcomeSection(() => bookedBetSuccessRef.value);
  }
});

watch(showSuccess, (isVisible) => {
  if (isVisible) {
    focusBetslipOutcomeSection(() => betslipSuccessRef.value);
  }
});

const handleStakeKeydown = (event: KeyboardEvent) => {
  if (event.key === ',') event.preventDefault();
};

const endStakeEditing = (index: number) => {
  const next = { ...stakeEditingByIndex.value };
  delete next[index];
  stakeEditingByIndex.value = next;
  delete localStakeValues.value[index];
};

const commitStakeInput = (index: number, rawInput: string) => {
  const allowDec = unref(allowDecimals);
  const parsed = parseCommittedStakeInput(rawInput, allowDec);
  if (parsed == null) {
    setRawBetStake(index, 0);
    return;
  }
  applyNormalizedStake(index, parsed);
};

const flushPendingStakeEdits = () => {
  const editingIndices = Object.keys(stakeEditingByIndex.value).map(Number);
  for (const index of editingIndices) {
    if (!Number.isFinite(index)) continue;
    commitStakeInput(index, localStakeValues.value[index] ?? "");
    endStakeEditing(index);
  }
};

const handleStakeFocus = (_event: FocusEvent, index: number) => {
  stakeEditingByIndex.value = { ...stakeEditingByIndex.value, [index]: true };
  const bet = bets.value[index];
  const stake = bet?.stake ?? 0;
  localStakeValues.value[index] =
    stake > 0 ? formatStakeInputValue(stake) : "";
};

const handleStakeBlur = (event: FocusEvent, index: number) => {
  const input = event.target as HTMLInputElement;
  commitStakeInput(index, input.value);
  endStakeEditing(index);
};

const handleStakeChange = (event: Event, index: number) => {
  const input = event.target as HTMLInputElement;
  const value = sanitizeStakeInputString(input.value, unref(allowDecimals));
  localStakeValues.value[index] = value;

  if (value === "" || value === ".") {
    setRawBetStake(index, 0);
    return;
  }

  const previewStake = parseStakePreviewAmount(value);
  if (previewStake > 0) {
    setRawBetStake(index, previewStake);
  } else {
    setRawBetStake(index, 0);
  }
};

const validateBetLimitsBeforeSubmit = (): string | null => {
  const maxPerLine = unref(betMax);
  const minPerLine = unref(betMin);
  const maxPayout = unref(payoutMax);
  const maxTotalStake = unref(betLimit);
  const applyPayoutMaxToBetslip = unref(payoutMaxPerBetslip);

  for (const bet of bets.value) {
    const stake = toNumber(bet.stake);
    const { drawCount, numBets } = getBetLineMultipliers(bet);

    if (minPerLine > 0 && stake < minPerLine) {
      return `Bet amount is below the minimum limit.`;
    }
    if (maxPerLine > 0 && stake > maxPerLine) {
      return `Bet amount exceeds the maximum limit. Maximum allowed bet per selection is ${maxPerLine}.`;
    }

    if (!applyPayoutMaxToBetslip && maxPayout > 0) {
      const odds = toNumber(bet.odds);
      if (odds > 0) {
        const potentialWin = calcPotentialWin(stake, odds, drawCount, numBets);
        if (potentialWin > maxPayout) {
          return t('betslip.winningsMustBeSmallerThan', { amount: maxPayout });
        }
      }
    }
  }

  if (applyPayoutMaxToBetslip && maxPayout > 0) {
    const totalPotentialWin = sumPotentialWins(betPotentialInputs.value);
    if (totalPotentialWin > maxPayout) {
      return t('betslip.winningsMustBeSmallerThan', { amount: maxPayout });
    }
  }

  if (maxTotalStake > 0 && totalStake.value > maxTotalStake) {
    return t('betslip.totalStakeExceedsMax', { amount: maxTotalStake });
  }

  return null;
};

const hasSelectedNumbers = (numbers: any) => {
  if (!numbers) return false;
  if (Array.isArray(numbers)) {
    return numbers.some(group => Array.isArray(group) && group.length > 0);
  }
  return false;
};

const lastBetReference = ref<string | null>(null);

const handleBetButtonClick = () => {
  if (!isAuthenticated.value) {
    // Send login request to parent (works for both iframe and non-iframe)
    iframeCommunication.sendLoginRequest('bet-attempt');
    
    // If not in iframe, we can also emit an event or show a message
    if (!iframeCommunication.isRunningInIframe()) {
      // For non-iframe mode, show a toast or redirect to login
      showToast({
        title: t('toast.loginRequired'),
        message: t('toast.loginRequiredMsg'),
        type: 'info',
        duration: 3000
      });
    }
    return;
  }
  placeBet();
};

const placeBet = async () => {
  flushPendingStakeEdits();
  if (isProcessingBet.value || isEmpty.value || exceedsBetslipPayoutMax.value) return;
  if (!handleExpiredBets()) return;
  const maxBets = gameStore.getBetSettings?.payload_max || 2000;
  if (bets.value.length > maxBets) {
    showToast({
      title: t('betslip.maxBetsExceeded'),
      message: t('betslip.maxBetsExceededMsg', { count: bets.value.length, max: maxBets }),
      type: "error",
      duration: 4000,
    });
    return;
  }
  const invalidBets = bets.value.filter(b => !b.outcome_id || b.outcome_id === "");
  if (invalidBets.length > 0) {
    showSuccess.value = false;
    showToast({
      title: t('betslip.invalidBetConfig'),
      message: t('betslip.invalidBetConfigMsg'),
      type: "error",
      duration: 4000,
    });
    return;
  }
  const limitError = validateBetLimitsBeforeSubmit();
  if (limitError) {
    inlineError.value = limitError;
    showToast({ title: t("common.error"), message: limitError, type: "error", duration: 5000 });
    return;
  }
  const promotionError = promotionStore.isAppliedOnSlip
    ? promotionStore.validateSlip({
        lineCount: bets.value.length,
        totalStake: totalStake.value,
        currency: unref(sessionCurrencyCode),
        gameSlugs: resolveBetGameSlugs(),
      })
    : null;
  if (promotionError) {
    inlineError.value = promotionError;
    showToast({ title: t("common.error"), message: promotionError, type: "error", duration: 5000 });
    return;
  }
  inlineError.value = null;
  isProcessingBet.value = true;
  try {
    const payload = buildBackendPayload();
    const result = await transactionsStore.createBet(payload);
    if (result.status === "success") {
      const promotionPayload = promotionStore.getPlaceBetPayload();
      lastBetReference.value = result.bets_processed.reference;
      showSuccess.value = true;
      showToast({
        title: t('betslip.betPlacedSuccess'),
        message: t('betslip.goodLuck'),
        type: "success",
        duration: 3000,
      });
      const betPlacedPayload = {
        reference: result.bets_processed.reference,
        totalStake: totalStake.value,
        ...(promotionPayload
          ? {
              paidAmount: result.paid_amount ?? 0,
              discountAmount: result.discount_amount ?? totalStake.value,
              promotionType: promotionPayload.type,
              promotionId: result.promotion_id ?? promotionPayload.id,
            }
          : result.promotion
            ? {
                paidAmount: result.paid_amount ?? 0,
                discountAmount: result.discount_amount ?? totalStake.value,
                promotionType: result.promotion_type ?? result.promotion?.type,
                promotionId: result.promotion_id ?? result.promotion?.id,
              }
            : {}),
        ...(typeof result.booking_code === "string" && result.booking_code
          ? { bookingCode: result.booking_code }
          : {}),
        ...(result.bet_placed_event && typeof result.bet_placed_event === "object"
          ? result.bet_placed_event
          : {}),
      };
      iframeCommunication.notifyBetPlaced(betPlacedPayload);
      if (promotionPayload) {
        promotionStore.clear('consumed');
      }
      if (!useOnlinePlatformPrintModal.value) {
        let betsSnapshot: BetslipItem[] = [];
        try {
          betsSnapshot = JSON.parse(JSON.stringify(bets.value)) as BetslipItem[];
        } catch {
          betsSnapshot = [...bets.value];
        }
        const receiptPayload = {
          ...betPlacedPayload,
          bets: betsSnapshot,
        };
        iframeCommunication.sendMessage("bet-receipt-external", receiptPayload);
        try {
          window.dispatchEvent(
            new CustomEvent("numbers-online-bet-receipt", { detail: receiptPayload })
          );
        } catch {
          /* ignore */
        }
      }
      emit("clearedAfterSubmission");
      currentBookingCode.value = null;
      clearBetslip(false);
      focusBetslipOutcomeSection(() => betslipSuccessRef.value);
      await transactionsStore.fetchTransactions();
      setTimeout(() => { showSuccess.value = false; }, 3000);
      setTimeout(() => { emit("close"); }, 5000);
    } else {
      throw new Error("Failed to place bet");
    }
  } catch (error: any) {
    showSuccess.value = false;
    const errorMessage = error?.userMessage || t('betslip.failedToPlaceBet');
    inlineError.value = errorMessage;
    showToast({ title: t('common.error'), message: errorMessage, type: "error", duration: 5000 });
    setTimeout(() => { inlineError.value = null; }, 5000);
  } finally {
    isProcessingBet.value = false;
  }
};

const handleLastBetRebet = () =>
  applyRebetFromCurrentTransaction({
    onComplete: () => {
      isLastBetModalOpen.value = false;
    },
    openBetslip: false,
  });

const viewLastBet = async () => {
  if (!lastBetReference.value) return;
  try {
    isLoadingLastBet.value = true;
    await transactionsStore.fetchTransactionDetail(lastBetReference.value);
    isLastBetModalOpen.value = true;
  } catch (error) {
    showToast({
      title: t('common.error'),
      message: t('betslip.failedToLoadLastBet'),
      type: "error",
      duration: 4000,
    });
  } finally {
    isLoadingLastBet.value = false;
  }
};

const viewWagers = () => {
  emit("close");
  nextTick(() => router.push({ path: "/wagers", query: route.query }));
};

const handleBookBet = async () => {
  flushPendingStakeEdits();
  if (isEmpty.value || isProcessingBookBet.value || isBookBetDisabled.value) return;
  authStore.refreshAuthFromExternalSources();
  if (!hasAccountForBooking.value) {
    showToast({
      title: t('toast.accountRequired'),
      message: t('toast.accountRequiredBookMsg'),
      type: 'info',
      duration: 5000,
    });
    return;
  }
  if (!handleExpiredBets()) return;
  isProcessingBookBet.value = true;
  try {
    const currentBets = [...bets.value];
    const result = await transactionsStore.bookBet(buildBackendPayload());
    if (result?.status === "success") {
      currentBookingCode.value = result.booking_code || null;
      bookBetSuccessData.value = { booking_code: result.booking_code || "", barcode: result.barcode, expires_at: result.expires_at, total_bet_amount: result.total_bet_amount, bets: currentBets };
      emit("clearedAfterSubmission");
      clearBetslip(false);
      focusBetslipOutcomeSection(() => bookedBetSuccessRef.value);
      showToast({ title: t('toast.betBooked'), message: t('toast.betBookedMsg'), type: "success", duration: 3000 });
    } else {
      throw new Error(result?.message || "Failed to book bet");
    }
  } catch (err: any) {
    showToast({ title: t('common.error'), message: err?.userMessage || err?.message || t('toast.failedToBookBet'), type: "error", duration: 5000 });
  } finally {
    isProcessingBookBet.value = false;
  }
};

const loadBookedBet = async () => {
  const code = bookingCodeInput.value?.trim();
  if (!code || isLoadingBooking.value) return;
  authStore.refreshAuthFromExternalSources();
  if (!hasAccountForBooking.value) {
    showToast({
      title: t('toast.accountRequired'),
      message: t('toast.accountRequiredLoadMsg'),
      type: 'info',
      duration: 5000,
    });
    return;
  }
  bookingMessage.value = "";
  bookingErrorMessage.value = "";
  bookBetSuccessData.value = null;
  isLoadingBooking.value = true;
  try {
    const result = await transactionsStore.loadBookedBet(code);
    const loadedBets = Array.isArray(result?.bet_data?.bets) ? result.bet_data.bets : [];

    if (result?.status === "success" && loadedBets.length > 0) {
      currentBookingCode.value = result.booking_code || null;
      storeClearBetslip();
      for (const b of loadedBets) {
        const draws = Array.isArray(b.draws) ? b.draws : [];
        const allAvailableDraws = Array.isArray(b.allAvailableDraws) ? b.allAvailableDraws : draws;
        const drawCount =
          typeof b.drawCount === "number" && b.drawCount > 0 ? b.drawCount : Math.max(draws.length, 1);
        const numBets =
          typeof b.numBets === "number" && b.numBets > 0 ? b.numBets : 1;

        betslipStore.addBet({
          market_id: b.market_id,
          market_group_id: b.market_group_id ?? 0,
          game_id: b.game_id,
          game_name: b.game_name,
          draws,
          allAvailableDraws,
          drawCount,
          numbers: Array.isArray(b.numbers) ? b.numbers : [[], []],
          stake: Number(b.stake) || 0,
          betType: b.betType,
          maxStake: typeof b.maxStake === "number" ? b.maxStake : undefined,
          odds: typeof b.odds === "string" ? parseFloat(b.odds) : b.odds,
          numBets,
          picks: b.picks,
          outcome_id: String(b.outcome_id ?? ""),
          label: b.label,
          market_name: b.market_name,
          market_description: b.market_description,
          specifier: b.specifier ?? null,
          select_numbers: Boolean(b.select_numbers),
          currency_symbol: b.currency_symbol,
        });
      }
      bookingCodeInput.value = "";
      bookingMessage.value = result.draws_updated
        ? t('toast.bookedBetLoadedDrawUpdated')
        : t('toast.bookedBetLoaded');
      setTimeout(() => { bookingMessage.value = ""; }, 5000);
    } else {
      bookingErrorMessage.value = result?.message || t('toast.noBetDataReturned');
      setTimeout(() => { bookingErrorMessage.value = ""; }, 5000);
    }
  } catch (err: any) {
    bookingErrorMessage.value = err?.userMessage || err?.message || t('toast.failedToLoadBookedBet');
    setTimeout(() => { bookingErrorMessage.value = ""; }, 5000);
  } finally {
    isLoadingBooking.value = false;
  }
};

const downloadBookedBarcode = async () => {
  const d = bookBetSuccessData.value;
  if (!d) return;
  
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) return;
  
  const width = 320;
  const padding = 20;
  let height = 220;
  if (d.barcode) height += 70;
  
  canvas.width = width;
  canvas.height = height;
  
  // White background
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, width, height);
  
  let y = padding;
  
  // Title
  ctx.fillStyle = "#333";
  ctx.font = "bold 16px Arial";
  ctx.textAlign = "center";
  ctx.fillText(t('betslip.receiptTitle'), width / 2, y + 10);
  y += 35;
  
  // Booking code
  ctx.fillStyle = "#2563EB";
  ctx.font = "bold 22px monospace";
  ctx.fillText(d.booking_code, width / 2, y + 10);
  y += 35;
  
  // Barcode
  if (d.barcode) {
    const img = new Image();
    img.src = `data:image/png;base64,${d.barcode}`;
    await new Promise<void>((resolve) => {
      img.onload = () => {
        const bw = width - padding * 2;
        const bh = 50;
        ctx.drawImage(img, padding, y, bw, bh);
        y += bh + 15;
        resolve();
      };
      img.onerror = () => resolve();
    });
  }
  
  // Divider
  ctx.strokeStyle = "#E5E5E5";
  ctx.beginPath();
  ctx.moveTo(padding, y);
  ctx.lineTo(width - padding, y);
  ctx.stroke();
  y += 15;
  
  // Details
  ctx.font = "12px Arial";
  ctx.textAlign = "left";
  
  const drawRow = (label: string, value: string) => {
    ctx.fillStyle = "#666";
    ctx.fillText(label, padding, y);
    ctx.fillStyle = "#333";
    ctx.textAlign = "right";
    ctx.fillText(value, width - padding, y);
    ctx.textAlign = "left";
    y += 20;
  };
  
  drawRow(t('betslip.receiptAmountLabel'), formatCurrency(d.total_bet_amount || 0, unref(displayCurrency)));
  drawRow(t('betslip.receiptBetsLabel'), String(d.bets?.length || 0));
  drawRow(t('betslip.receiptExpiresLabel'), formatDate(d.expires_at || ''));
  
  y += 10;
  
  // Footer
  ctx.fillStyle = "#999";
  ctx.font = "10px Arial";
  ctx.textAlign = "center";
  ctx.fillText(t('betslip.scanOrUseCode'), width / 2, y);
  
  // Download
  const link = document.createElement("a");
  link.href = canvas.toDataURL("image/png");
  link.download = `booking-${d.booking_code}.png`;
  link.click();
};

const isDrawExpired = (draw: string | { draw_date: string; cutoff: string }) => {
  let cutoffTime = new Date(typeof draw === "string" ? draw : (draw?.cutoff || draw?.draw_date));
  return !isNaN(cutoffTime.getTime()) && cutoffTime.getTime() <= new Date().getTime();
};

const validateDraws = () => {
  return !bets.value.some(bet => Array.isArray(bet.draws) && bet.draws.some(d => isDrawExpired(d)));
};

const handleExpiredBets = () => {
  const expired: any[] = [];
  bets.value.forEach((bet, betIndex) => {
    if (Array.isArray(bet.draws)) {
      bet.draws.forEach((draw, drawIndex) => {
        if (isDrawExpired(draw)) expired.push({ betIndex, drawIndex, draw });
      });
    }
  });
  if (expired.length > 0) {
    expiredBets.value = expired;
    showExpiredBetOptions.value = true;
    return false;
  }
  return true;
};

const collapsedDrawsVisibleCount = (drawCount: number): number => {
  if (drawCount <= 1) return drawCount;
  if (drawCount === 2) return 1;
  return 2;
};

const betDrawsForDisplay = (
  draws: BetslipItem['draws'],
  betIndex: number,
): NonNullable<BetslipItem['draws']> => {
  const list = Array.isArray(draws) ? draws : [];
  if (expandedDraws.value[betIndex]) return list;
  return list.slice(0, collapsedDrawsVisibleCount(list.length));
};

const hiddenDrawsCount = (drawCount: number, betIndex: number): number => {
  if (expandedDraws.value[betIndex] || drawCount <= 1) return 0;
  return drawCount - collapsedDrawsVisibleCount(drawCount);
};

const toggleDrawsExpanded = (betIndex: number) => {
  expandedDraws.value = {
    ...expandedDraws.value,
    [betIndex]: !expandedDraws.value[betIndex],
  };
};

const removeDrawFromBet = (betIndex: number, drawIndex: number) => {
  const bet = bets.value[betIndex];
  if (bet && Array.isArray(bet.draws) && bet.draws.length > 1) {
    bet.draws.splice(drawIndex, 1);
    betslipStore.saveToStorage();
    emit('drawsChanged', [...bet.draws]);
  }
};

const removeExpiredBets = () => {
  const sorted = [...expiredBets.value].sort((a, b) => {
    if (b.betIndex !== a.betIndex) return b.betIndex - a.betIndex;
    return b.drawIndex - a.drawIndex;
  });
  sorted.forEach(({ betIndex, drawIndex }) => {
    const bet = bets.value[betIndex];
    if (bet && Array.isArray(bet.draws)) {
      bet.draws.splice(drawIndex, 1);
      if (bet.draws.length === 0) removeBetAtIndex(betIndex);
    }
  });
  showExpiredBetOptions.value = false;
  expiredBets.value = [];
};

const moveToNextDraw = () => {
  let hasMovedAny = false;
  let failedMoves = 0;

  // Filter to only process single draw bets (draws.length === 1)
  const singleDrawExpiredBets = expiredBets.value.filter(({ betIndex }) => {
    const bet = bets.value[betIndex];
    return bet && Array.isArray(bet.draws) && bet.draws.length === 1;
  });

  if (singleDrawExpiredBets.length === 0) {
    inlineError.value = t('betslip.singleDrawMoveOnly');
    setTimeout(() => inlineError.value = null, 5000);
    return;
  }

  // Process each expired bet
  const updatedBets = [...bets.value];
  
  singleDrawExpiredBets.forEach((expiredBet) => {
    const bet = updatedBets[expiredBet.betIndex];
    
    if (!bet || !bet.allAvailableDraws || bet.allAvailableDraws.length === 0) {
      failedMoves++;
      return;
    }

    // Filter out expired draws and get the next available draw
    const validDraws = bet.allAvailableDraws.filter(draw => !isDrawExpired(draw));
    
    if (validDraws.length === 0) {
      failedMoves++;
      return;
    }

    const nextDraw = validDraws[0];
    
    // Update the bet with the next draw
    updatedBets[expiredBet.betIndex] = {
      ...bet,
      draws: [nextDraw]
    };
    hasMovedAny = true;
  });

  if (hasMovedAny) {
    betslipStore.betslip = updatedBets;
    betslipStore.saveToStorage();
  }

  showExpiredBetOptions.value = false;
  expiredBets.value = [];

  if (hasMovedAny && failedMoves === 0) {
    showToast({
      title: t('common.success'),
      message: t('betslip.betsMovedToNextDraw'),
      type: 'success',
    });
  } else if (hasMovedAny && failedMoves > 0) {
    showToast({
      title: t('common.warning'),
      message: t('betslip.someBetsMovedWarning', { count: failedMoves }),
      type: 'info',
    });
  } else {
    inlineError.value = t('betslip.noNextDrawAvailable');
    setTimeout(() => inlineError.value = null, 5000);
  }
};

const hasExpiredDraws = (bet: any) => {
  return Array.isArray(bet.draws) && bet.draws.some((d: any) => isDrawExpired(d));
};

const hasAnyGameWithNextDraw = computed(() => {
  return expiredBets.value.some(({ betIndex }) => {
    const b = bets.value[betIndex];
    if (!(b && Array.isArray(b.draws) && b.draws.length === 1)) return false;
    
    // Check if there is an available draw in allAvailableDraws
    return b.allAvailableDraws && b.allAvailableDraws.some(draw => !isDrawExpired(draw));
  });
});

const cleanupExpiredDraws = () => {
  if (!betslip.value || !validateDraws()) return;
};

const formatDate = (date: string | undefined | null) => {
  if (!date) return "";
  const d = new Date(date);
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  const seconds = d.getSeconds().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

const buildBackendPayload = () => {
  const bookingCode =
    typeof currentBookingCode.value === 'string' ? currentBookingCode.value.trim() : '';

  const betsPayload = bets.value.map((bet) => ({
    game_id: bet.game_id,
    market_id: bet.market_id,
    market_group_id: Number(bet.market_group_id),
    draws: Array.isArray(bet.draws) ? bet.draws : [],
    numbers: bet.numbers,
    picks: bet.picks,
    stake: bet.stake,
    outcome_id: bet.outcome_id,
  }));

  return {
    bets: betsPayload,
    total_bet_amount: totalStake.value,
    currency: unref(sessionCurrencyCode),
    ...(bookingCode ? { booking_code: bookingCode } : {}),
    ...((): Record<string, unknown> => {
      const promotion = promotionStore.getPlaceBetPayload()
      return promotion ? { promotion } : {}
    })(),
  };
};

const handlePlacePromotionEvent = () => {
  if (!promotionStore.isAppliedOnSlip || isEmpty.value || isProcessingBet.value) return;
  void placeBet();
};

onMounted(() => {
  isMobile.value = window.innerWidth <= 768;
  window.addEventListener('resize', () => isMobile.value = window.innerWidth <= 768);
  cleanupTimer.value = window.setInterval(cleanupExpiredDraws, 30000);
  window.addEventListener('bitville:place-promotion', handlePlacePromotionEvent);

  authStore.refreshAuthFromExternalSources();
  void (async () => {
    try {
      if (!gameStore.getBetSettings) {
        await gameStore.fetchGameSettings(false);
      }
      await refreshPromotions(undefined, { silent: true });
    } catch {
      /* optional */
    } finally {
      promotionLookupDone.value = true;
    }
  })();
});

onUnmounted(() => {
  if (cleanupTimer.value) clearInterval(cleanupTimer.value);
  window.removeEventListener('bitville:place-promotion', handlePlacePromotionEvent);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      ref_key: "betslipContainer",
      ref: betslipContainer,
      class: "betslip"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('betslip.title')), 1),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header-line" }, null, -1))
      ]),
      (showBookABetModule.value && !_unref(promotionStore).isAppliedOnSlip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bookingCodeInput).value = $event)),
                type: "text",
                inputmode: "text",
                "data-keyboard": "alphanumeric",
                class: "booking-search-input",
                placeholder: _ctx.$t('betslip.enterBookingCode'),
                onKeyup: _withKeys(loadBookedBet, ["enter"])
              }, null, 40, _hoisted_4), [
                [_vModelText, bookingCodeInput.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "booking-search-button",
                disabled: !bookingCodeInput.value.trim() || isLoadingBooking.value,
                onClick: loadBookedBet
              }, _toDisplayString(isLoadingBooking.value ? _ctx.$t('betslip.loading') : _ctx.$t('betslip.load')), 9, _hoisted_5)
            ]),
            (bookingMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(bookingMessage.value), 1))
              : _createCommentVNode("", true),
            (bookingErrorMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(bookingErrorMessage.value), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (bets.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (bookBetSuccessData.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref_key: "bookedBetSuccessRef",
                  ref: bookedBetSuccessRef,
                  class: "booked-bet-success-inline",
                  tabindex: "-1"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "check-icon" }, "✓", -1)),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('betslip.betBookedSuccess')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(bookBetSuccessData.value.booking_code), 1)
                  ]),
                  (bookBetSuccessData.value.barcode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("img", {
                          src: `data:image/png;base64,${bookBetSuccessData.value.barcode}`,
                          alt: "Barcode",
                          class: "barcode-img"
                        }, null, 8, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('betslip.totalAmount')), 1),
                      _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(bookBetSuccessData.value.total_bet_amount || 0, unref(displayCurrency.value))), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('betslip.expires')), 1),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(formatDate(bookBetSuccessData.value.expires_at || '')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("button", {
                      class: "download-btn",
                      onClick: downloadBookedBarcode
                    }, _toDisplayString(_ctx.$t('betslip.downloadReceipt')), 1),
                    _createElementVNode("button", {
                      class: "done-btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (bookBetSuccessData.value = null))
                    }, _toDisplayString(_ctx.$t('common.done')), 1)
                  ])
                ], 512))
              : (showSuccess.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    ref_key: "betslipSuccessRef",
                    ref: betslipSuccessRef,
                    class: "success-message",
                    tabindex: "-1"
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "success-icon" }, "🎉", -1)),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('betslip.betPlacedSuccess')), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('betslip.goodLuck')), 1)
                      ])
                    ])
                  ], 512))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('betslip.empty')), 1)
                  ])),
            (isAuthenticated.value && !bookBetSuccessData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (lastBetReference.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "view-bet-button",
                        disabled: isLoadingLastBet.value,
                        onClick: viewLastBet
                      }, _toDisplayString(isLoadingLastBet.value ? _ctx.$t('betslip.loadingLastBet') : _ctx.$t('betslip.viewLastBet')), 9, _hoisted_24))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "view-bet-button",
                    onClick: viewWagers
                  }, _toDisplayString(_ctx.$t('betslip.viewWagers')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bets.value, (bet, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["bet-item", { 'expired-bet': showExpiredBetOptions.value && hasExpiredDraws(bet) }])
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(bet.game_name), 1),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(bet.odds), 1),
                      _createElementVNode("button", {
                        class: "remove-bet-btn",
                        "aria-label": _ctx.$t('betslip.removeBet'),
                        onClick: ($event: any) => (removeBetAtIndex(index))
                      }, _cache[8] || (_cache[8] = [
                        _createElementVNode("svg", {
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          class: "trash-icon-svg"
                        }, [
                          _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                          _createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
                        ], -1)
                      ]), 8, _hoisted_30)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('betslip.draws')) + " (" + _toDisplayString(bet.draws?.length || 0) + "):", 1),
                        (bet.draws && bet.draws.length > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "toggle-draws-btn",
                              "aria-expanded": expandedDraws.value[index],
                              onClick: ($event: any) => (toggleDrawsExpanded(index))
                            }, [
                              _createTextVNode(_toDisplayString(expandedDraws.value[index] ? _ctx.$t('common.hide') : _ctx.$t('common.show')) + " ", 1),
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass(["chevron-icon", { 'rotated': expandedDraws.value[index] }]),
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2"
                              }, _cache[9] || (_cache[9] = [
                                _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                              ]), 2))
                            ], 8, _hoisted_35))
                          : _createCommentVNode("", true)
                      ]),
                      (bet.draws && bet.draws.length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["draws-list", { 'expanded': expandedDraws.value[index] }])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(betDrawsForDisplay(bet.draws, index), (draw, drawIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: draw.event_id || drawIndex,
                                class: _normalizeClass(["draw-item", { 'expired': isDrawExpired(draw) }])
                              }, [
                                _createElementVNode("span", _hoisted_36, _toDisplayString(formatDate(draw.draw_date)), 1),
                                (bet.draws.length > 1)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "remove-draw-btn",
                                      "aria-label": _ctx.$t('betslip.removeDraw'),
                                      onClick: ($event: any) => (removeDrawFromBet(index, drawIndex))
                                    }, _cache[10] || (_cache[10] = [
                                      _createElementVNode("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      }, [
                                        _createElementVNode("line", {
                                          x1: "18",
                                          y1: "6",
                                          x2: "6",
                                          y2: "18"
                                        }),
                                        _createElementVNode("line", {
                                          x1: "6",
                                          y1: "6",
                                          x2: "18",
                                          y2: "18"
                                        })
                                      ], -1)
                                    ]), 8, _hoisted_37))
                                  : _createCommentVNode("", true)
                              ], 2))
                            }), 128)),
                            (hiddenDrawsCount(bet.draws.length, index) > 0)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "more-draws-indicator clickable",
                                  onClick: ($event: any) => (toggleDrawsExpanded(index))
                                }, " +" + _toDisplayString(hiddenDrawsCount(bet.draws.length, index)) + " " + _toDisplayString(_ctx.$t('betslip.moreDraws')), 9, _hoisted_38))
                              : _createCommentVNode("", true)
                          ], 2))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_39, _toDisplayString(formatMarketDisplay(bet)), 1),
                    (bet.betType && (!useAltNameForMarket.value || !hasSelectedNumbers(bet.numbers)))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.$t('betslip.betType')) + ": " + _toDisplayString(bet.betType), 1))
                      : _createCommentVNode("", true),
                    (bet.numbers && hasSelectedNumbers(bet.numbers))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('betslip.numbersChosen')) + ": ", 1),
                          _createElementVNode("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.isArray(bet.numbers) && Array.isArray(bet.numbers[0]) ? bet.numbers[0] : [], (number) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: 'main-' + number,
                                class: "number-circle"
                              }, _toDisplayString(number), 1))
                            }), 128)),
                            (Array.isArray(bet.numbers) && Array.isArray(bet.numbers[1]) && bet.numbers[1].length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "plus-sign" }, "+", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bet.numbers[1], (bonus) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: 'bonus-' + bonus,
                                      class: "number-circle bonus"
                                    }, _toDisplayString(bonus), 1))
                                  }), 128))
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t('betslip.stake')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(unref(displayCurrency.value)), 1),
                          _createElementVNode("input", {
                            type: "text",
                            inputmode: "decimal",
                            "data-keyboard": "decimal",
                            value: getStakeDisplayValue(index),
                            onInput: (event) => handleStakeChange(event, index),
                            onBlur: (event) => handleStakeBlur(event, index),
                            onFocus: (event) => handleStakeFocus(event, index),
                            onKeydown: _cache[2] || (_cache[2] = (event) => handleStakeKeydown(event))
                          }, null, 40, _hoisted_49)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t('betslip.toWin')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("span", _hoisted_53, _toDisplayString(unref(displayCurrency.value)), 1),
                          _createElementVNode("span", _hoisted_54, _toDisplayString(formatCurrencyValue(lineDisplayPotentials.value[index] ?? 0)), 1)
                        ])
                      ])
                    ])
                  ])
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                (showPromotionOffer.value)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 0,
                      class: "promotion-offer-inline",
                      title: _ctx.$t('betslip.promotionOptionalHint')
                    }, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "promotion-offer-checkbox",
                        checked: _unref(promotionStore).applyToSlip,
                        onChange: handlePromotionApplyToggle
                      }, null, 40, _hoisted_58),
                      _createElementVNode("span", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('betslip.usePromotion')), 1),
                        _createElementVNode("span", _hoisted_61, _toDisplayString(promotionBannerText.value), 1)
                      ])
                    ], 8, _hoisted_57))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "clear-all-btn",
                  onClick: clearBetslip
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "trash-icon-small"
                  }, [
                    _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                    _createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.clearAll')), 1)
                ])
              ]),
              (showPromotionOffer.value && _unref(promotionStore).applyToSlip && promotionSlipValidationError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(promotionSlipValidationError.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t('betslip.totalBetAmount')), 1),
                  _createElementVNode("span", _hoisted_66, _toDisplayString(_unref(formatCurrency)(totalStake.value, unref(displayCurrency.value))), 1)
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('betslip.totalPotentialReturns')), 1),
                  _createElementVNode("span", _hoisted_69, _toDisplayString(_unref(formatCurrency)(totalReturns.value, unref(displayCurrency.value))), 1)
                ])
              ]),
              (showExpiredBetOptions.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "warning-icon" }, "⚠️", -1)),
                      _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('betslip.expiredBets')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("button", {
                        class: "remove-expired-btn",
                        onClick: removeExpiredBets
                      }, _toDisplayString(_ctx.$t('betslip.remove')), 1),
                      (hasAnyGameWithNextDraw.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "move-to-next-btn",
                            onClick: moveToNextDraw
                          }, _toDisplayString(_ctx.$t('betslip.moveToNext')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (inlineError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "error-icon" }, "❌", -1)),
                    _createElementVNode("span", _hoisted_75, _toDisplayString(inlineError.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (showBookABetModule.value && bookBetRestrictionMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                    _cache[15] || (_cache[15] = _createStaticVNode("<span class=\"warning-icon\" aria-hidden=\"true\" data-v-6281c685><svg viewBox=\"0 0 20 20\" fill=\"none\" class=\"info-icon-svg\" data-v-6281c685><circle cx=\"10\" cy=\"10\" r=\"7\" stroke=\"currentColor\" stroke-width=\"1.8\" data-v-6281c685></circle><path d=\"M10 8V12\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" data-v-6281c685></path><circle cx=\"10\" cy=\"5.8\" r=\"1\" fill=\"currentColor\" data-v-6281c685></circle></svg></span>", 1)),
                    _createElementVNode("span", _hoisted_77, _toDisplayString(bookBetRestrictionMessage.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("button", {
                  class: _normalizeClass(["bet-now-btn", {
                processing: isProcessingBet.value,
                unauthenticated: !isAuthenticated.value,
                'payout-max-exceeded': exceedsBetslipPayoutMax.value && isAuthenticated.value,
              }]),
                  disabled: isAuthenticated.value ? (isProcessingBet.value || isEmpty.value || showExpiredBetOptions.value || exceedsBetslipPayoutMax.value) : false,
                  onClick: handleBetButtonClick
                }, [
                  (exceedsBetslipPayoutMax.value && isAuthenticated.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_80, [
                        _cache[16] || (_cache[16] = _createElementVNode("svg", {
                          viewBox: "0 0 20 20",
                          fill: "none",
                          class: "payout-max-warning-icon",
                          "aria-hidden": "true"
                        }, [
                          _createElementVNode("circle", {
                            cx: "10",
                            cy: "10",
                            r: "7",
                            stroke: "currentColor",
                            "stroke-width": "1.8"
                          }),
                          _createElementVNode("path", {
                            d: "M10 8V12",
                            stroke: "currentColor",
                            "stroke-width": "1.8",
                            "stroke-linecap": "round"
                          }),
                          _createElementVNode("circle", {
                            cx: "10",
                            cy: "5.8",
                            r: "1",
                            fill: "currentColor"
                          })
                        ], -1)),
                        _createElementVNode("span", null, _toDisplayString(betNowPayoutMaxMessage.value), 1)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(!isAuthenticated.value ? _ctx.$t('auth.pleaseLogin') : (isProcessingBet.value ? _ctx.$t('betslip.pleaseWait') : _ctx.$t('betslip.betNow'))), 1)
                      ], 64))
                ], 10, _hoisted_79),
                (showBookABetModule.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(["book-bet-btn", { processing: isProcessingBookBet.value }]),
                      disabled: isBookBetDisabled.value,
                      onClick: handleBookBet
                    }, _toDisplayString(isProcessingBookBet.value ? _ctx.$t('betslip.pleaseWait') : _ctx.$t('betslip.bookBet')), 11, _hoisted_81))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.$t('betslip.tsAndCs')), 1),
              _createElementVNode("button", {
                class: "close-betslip-button",
                onClick: closeBetslip
              }, _toDisplayString(_ctx.$t('common.close')), 1)
            ])
          ], 64))
    ], 512),
    _createVNode(BaseModal, {
      "is-open": isLastBetModalOpen.value,
      title: _ctx.$t('betslip.lastBetDetails'),
      "full-screen": "",
      "hide-footer": "",
      "flush-body": "",
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isLastBetModalOpen.value = false))
    }, {
      default: _withCtx(() => [
        (_unref(transactionsStore).currentTransaction)
          ? (_openBlock(), _createBlock(TransactionDetails, {
              key: 0,
              transaction: _unref(transactionsStore).currentTransaction,
              "is-rebetting": _unref(isRebetting),
              onRebet: handleLastBetRebet,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (isLastBetModalOpen.value = false))
            }, null, 8, ["transaction", "is-rebetting"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-open", "title"])
  ]))
}
}

})